<!--title -->
<app-modal-title
  [title]="'common.testSend' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content tw-w-[500px]">
  <!-- form -->
  <form [formGroup]="form">
    <!-- messageInformation -->

    <div class="row">
      <!-- senderNumberId + smsBody -->
      <app-sms-body
        [form]="form"
        smsBodyControlName="smsBody"
        senderNumberControlName="senderNumberId"
        [isShowSmsPreview]="false"
        voiceMessageControlName="voiceMessageId"
        maxTryCountControlName="maxTryCount"
        minuteBetweenTriesControlName="minuteBetweenTries"
        [isAddSignature]="true"
        [isShowSenderNumberId]="false"
        [isAddHeader]="true"
        [senderNumberId]="input_privateNumberId"
        (smsBody)="smsBody = $event"
        (finalSmsBody)="finalSmsBody = $event"
        (senderNumberId)="input_privateNumberId = $event"
        [isCanSendVoice]="isCanSendVoice"
        (senderNumber)="isCanSendVoice = $event?.isCanSendVoice"
        (voiceMessageDetails)="voiceMessageDetails = $event"
      >
      </app-sms-body>

      <!-- fast send -->
      <div class="align-items-start tw-mt-3">
        <div class="tw-w-full tw-mr-1 tw-mb-2">
          <span class="text-danger">*</span>
          <span
            class="tw-text-gray-700 dark:tw-text-gray-300"
            translate
            [translateParams]="{ number: 5 }"
          >
            messages.maxReceiversMsg
          </span>
        </div>

        <div class="tw-w-full">
          <app-chip-list
            [maxLength]="10"
            [title]="'common.receivers'"
            controlNreceiversame="receivers"
            [placeholder]="'messages.separateByCommaAndEnter' | translate"
            [checkInputWhenBlur]="true"
            (items)="fastSendReceivers = $event"
          >
          </app-chip-list>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [customTitle]="'common.fastSend' | translate"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
